$(function(){
    lightbox.option({
        showImageNumberLabel: false,
      })
    jQuery('.wrapper-gal-item a').attr('data-lightbox','environnement');
    jQuery('.wrapper-gal-item a').on('click', function(){
        lightbox.start(jQuery(this));
        return false;
    });
});